import { Component, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { isAdminRole } from '../../../core/utils/admin-role';
import { PeopleSearchBarComponent } from '../../../shared/people-search-bar/people-search-bar.component';

@Component({
  selector: 'app-landing-navbar',
  standalone: true,
  imports: [CommonModule, RouterLink, PeopleSearchBarComponent],
  templateUrl: './landing-navbar.component.html',
  styleUrl: './landing-navbar.component.scss',
})
export class LandingNavbarComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);

  loginModalOpen = signal(false);
  signupModalOpen = signal(false);
  forgotPasswordModalOpen = signal(false);

  ngOnInit(): void {
    const qp = this.router.parseUrl(this.router.url).queryParams;
    if (qp['openLogin'] === '1') {
      this.loginModalOpen.set(true);
      void this.router.navigateByUrl('/', { replaceUrl: true });
    } else if (qp['openSignup'] === '1') {
      this.signupModalOpen.set(true);
      void this.router.navigateByUrl('/', { replaceUrl: true });
    }
  }

  openLoginModal(): void {
    this.loginModalOpen.set(true);
  }

  closeLoginModal(): void {
    this.loginModalOpen.set(false);
  }

  openSignupModal(): void {
    this.signupModalOpen.set(true);
  }

  closeSignupModal(): void {
    this.signupModalOpen.set(false);
  }

  openForgotPasswordModal(): void {
    this.forgotPasswordModalOpen.set(true);
  }

  closeForgotPasswordModal(): void {
    this.forgotPasswordModalOpen.set(false);
  }

  onLoginSuccess(): void {
    this.closeLoginModal();
    this.navigateAfterAuth();
  }

  onRegisterClick(): void {
    this.closeLoginModal();
    this.openSignupModal();
  }

  onSignupLoginClick(): void {
    this.closeSignupModal();
    this.openLoginModal();
  }

  onRegisterSuccess(): void {
    this.closeSignupModal();
    this.navigateAfterAuth();
  }

  private navigateAfterAuth(): void {
    const path = isAdminRole(this.authService.currentUser()?.role) ? '/admin' : '/wishlists';
    void this.router.navigateByUrl(path);
  }
}
